import { render, staticRenderFns } from "./WorkOrderParticipators.vue?vue&type=template&id=5df4ceb0&scoped=true&"
import script from "./WorkOrderParticipators.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderParticipators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4ceb0",
  null
  
)

export default component.exports